define(
  'app/views/configurable_options_view',['app/setup', 'app/views/configurable_item_view', 'app/views/base_view'],
  function(takhfifan, configurableItemView, baseView) {

  takhfifan.ConfigurableOptionsView = takhfifan.BaseView.extend({

    initialize: function(options) {
      var _this=this;
      this.config = options.config;
      this.render();
      this.chosenAttributes={};
      this.chosenProducts={};
      takhfifan.eventHub.on('configurableProduct:addToCartCheck', function(data) {
          var validToProceed=true;
          var shown_no_option_error = false;
          var enableButtonEvent = data.$el && data.$el.hasClass('gift-btn') ? 'giftButton:enable': 'buyButton:enable';
          $.each(_this.config.attributes,function(key,attr) {
            if(!_this.chosenAttributes.hasOwnProperty(key) && !shown_no_option_error) {
              takhfifan.eventHub.trigger('message:show', { msg: 'لطفا تمام ویژگی ها را انتخاب نمایید',
              type:'error' });
              takhfifan.eventHub.trigger(enableButtonEvent, {});
              validToProceed=false;
              shown_no_option_error = true;
            }
          });
          if(validToProceed) {
            var count = 0;
            for (var k in _this.chosenProducts) {
              if (_this.chosenProducts.hasOwnProperty(k)) {
                ++count;
              }
            }
            if(count == 1) {
              var productToAdd=_this.chosenProducts[Object.keys(_this.chosenProducts)[0]];
              if(!productToAdd.isSoldOut && !productToAdd.isExpired) {
                takhfifan.eventHub.trigger(
                  'productaddtocart:configurable',
                  {
                    productId : Object.keys(_this.chosenProducts)[0],
                    parentProductId: data.productId
                  }
                );
              }
              else if(productToAdd.isSoldOut) {
                takhfifan.eventHub.trigger('message:show', { msg: 'محصول با این ویژگی ها به اتمام رسیده است',
                type: 'error' });
                takhfifan.eventHub.trigger(enableButtonEvent,{});
              }
              else if(productToAdd.isExpired) {
                takhfifan.eventHub.trigger('message:show', { msg: 'فرصت خرید محصول با این ویژگی ها به اتمام رسیده است',
                type: 'error' });
                takhfifan.eventHub.trigger(enableButtonEvent,{});
              }
            }
            else
            {
              takhfifan.eventHub.trigger(enableButtonEvent,{});
            }
          }
      });

      takhfifan.eventHub.on('product:attributeChosen', function(data) {
        var finalPrice=0;
        this.chosenAttributes[data.attrId]={};
        _this.chosenAttributes[data.attrId].val=data.attrVal;
        if(data.attrVal == -1) {
          delete _this.chosenAttributes[data.attrId];
          finalPrice=data.basePrice;
        }
        else
        {
          _this.chosenAttributes[data.attrId].products=data.products;
          _this.chosenProducts=_.clone(_this.chosenAttributes[data.attrId].products);
          $.each(this.chosenAttributes,function(key,attr) {
             var products= attr.products;
             $.each(_this.chosenProducts,function(pkey,pVal) {
              if(!products.hasOwnProperty(pkey)) {
                delete _this.chosenProducts[pkey];
              }
             });
          });
          var count = 0;
          for (var k in this.chosenProducts) {
            if (this.chosenProducts.hasOwnProperty(k)) {
               ++count;
            }
          }
          if(count == 1) {
            finalPrice=0;
            if(count==1) {
              finalPrice=this.chosenProducts[Object.keys(this.chosenProducts)[0]].price/10;
            }
          }
        }
        var allAttributesChosen=true;
          $.each(_this.config.attributes,function(key,attr) {
            if(!_this.chosenAttributes.hasOwnProperty(key)) {
              allAttributesChosen=false;
            }
          });
        if(!allAttributesChosen) {
          finalPrice=data.basePrice/10;
        }
        var $priceContainer = this.$el.parents('.tkh-sale').first()
          .find('.tkh-price').find('.deal-final-price-number').first();
        var price = finalPrice;
        var formattedPrice = $priceContainer.data('template').
          replace(/%p/, price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "،"));
        $priceContainer.html(formattedPrice);
      }, this);
    },

    render: function(args) {
      var _this = this;
      var config = this.config;
      _.each(config.attributes, function(attribute) {
        var $list = _this.$('#tkh-configurable-option-' + attribute.id + ' ul.tkh-option-items').first();
        $list.empty();

        var options = attribute.options;
        options.unshift({products: [], label: i18n.t('please_choose'), id: null, price: 0});

        _.each(options, function(option){
          var $el = $('<li></li>');
          $list.append($el);
          option.superAttribute = attribute.id;
          new takhfifan.ConfigurableItemView({el: $el, model: _this.model, option: option});
        });
      });
      this.$(".dropdown-items li").on("click", function(){
          if(!($(".checkbox", $(this)).length > 0)){
              var dropdownItemsParent = $(this).parents("[class*='dropdown']");
              $(".dropdown-items li", dropdownItemsParent).removeClass("active");
              $(this).addClass("active");
              dropdownItemsParent.find(".default-text [class*='value']").text($(".active", dropdownItemsParent).text());
              dropdownItemsParent.removeClass("dropdown-visible");
              $(".item-arrow").removeClass("icon-arrow-drop-up").addClass("icon-arrow-drop-down");
              var target = $('#' + $(this).data('target'));
              target.val($(".active", dropdownItemsParent).text());

          }
        });
      this.$(".dropdown").each(function(i){
        if(i===0){
          $(this).addClass('dropdown-visible');
        }
        var defaultTextVal = $(this).find(".default-text .value");
        if($(this).find(".active").length){
            defaultTextVal.text($(".active", this).text());
        }
      });
    }

  });

});

